import { Tooltip as TooltipPrimitive } from "@base-ui/react/tooltip";
import type { ReactNode } from "react";
import { resolveClassName } from "./cn";

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export interface TooltipContentProps extends TooltipPrimitive.Popup.Props {
  readonly side?: TooltipPrimitive.Positioner.Props["side"];
  readonly sideOffset?: TooltipPrimitive.Positioner.Props["sideOffset"];
  readonly align?: TooltipPrimitive.Positioner.Props["align"];
}

export function TooltipContent({
  className,
  children,
  side = "top",
  sideOffset = 4,
  align = "center",
  ...props
}: TooltipContentProps) {
  const defaultClasses =
    "dropdown-glass rounded-md px-2 py-1 text-[11px] font-medium text-[var(--text)] shadow-md transition-opacity duration-150";

  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Positioner
        side={side}
        sideOffset={sideOffset}
        align={align}
        className="z-[140] select-none pointer-events-none"
      >
        <TooltipPrimitive.Popup className={resolveClassName(className, defaultClasses)} {...props}>
          {children}
        </TooltipPrimitive.Popup>
      </TooltipPrimitive.Positioner>
    </TooltipPrimitive.Portal>
  );
}

export function SimpleTooltip({
  content,
  children,
  side = "top",
}: {
  readonly content: ReactNode;
  readonly children: ReactNode;
  readonly side?: TooltipPrimitive.Positioner.Props["side"];
}) {
  return (
    <Tooltip>
      <TooltipTrigger render={<span className="inline-flex" />}>{children}</TooltipTrigger>
      <TooltipContent side={side}>{content}</TooltipContent>
    </Tooltip>
  );
}
